import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {extensionPublicAPI} = publicMethodUtils

    return {
        methods: {
            remoteStructureMetaData: {
                loadAll: extensionPublicAPI.immediate('remoteStructureMetaData.loadAll')
            }
        }
    }
}
